/* eslint-disable comma-dangle */

export default {
  address: [
    'coworking-name',
  ],
  'about-object': [
    'coworking-workplace-count',
    'coworking-total-area',
    'coworking-floor',
    'coworking-access-type',
    'coworking-price',
    'coworking-min-lease-term',
  ],
};
